import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import FluidAvatarImage from '../fluid-avatar-image';
import { resolveUserImage } from '@wix/communities-blog-client-common';
import withMediaHosts from '../../hoc/with-media-hosts';
import styles from './header-avatar-image.scss';

const IMAGE_SIZE = parseInt(styles.IMAGE_SIZE, 10) * 2;

const HeaderAvatarImage = ({ user, imageHost }) => (
  <div className={classNames(styles.container, 'header-avatar-image')}>
    <div className={styles.image}>
      <FluidAvatarImage image={resolveUserImage(user.image, { width: IMAGE_SIZE, height: IMAGE_SIZE, imageHost })} />
    </div>
  </div>
);

HeaderAvatarImage.propTypes = {
  user: PropTypes.object.isRequired,
  imageHost: PropTypes.string,
};

export default withMediaHosts(HeaderAvatarImage);
